import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const PhotoTimelineSkeleton: React.FC = () => (
  <div className="space-y-3">
    <Skeleton className="h-5 w-48" />
    <div className="grid grid-cols-5 gap-2">
      {Array.from({ length: 10 }).map((_, i) => (
        <Skeleton key={i} className="aspect-square w-full" />
      ))}
    </div>
  </div>
)

export default PhotoTimelineSkeleton
